(function () {
    "use strict";

    var app = angular.module('iMatApp');

    app.constant("modelViewerSettings", {
        maxModelSizeKb: 30720
    });

    app.factory("modelViewerService", modelViewerService);
    modelViewerService.$inject = ["$q", "$log", "modelViewerSettings", "guard", "eventService"];

    function modelViewerService($q, $log, settings, guard, eventService) {
        var msvWidget;
        var isWebGlSupportedCached = null;

        return {
            isWebGlSupported: isWebGlSupported,
            isFormatSupported: isFormatSupported,
            canBeShowDirectly: canBeShowDirectly,
            canBeShownBy3DViewer: canBeShownBy3DViewer,

            initViewer: initViewer,

            showModelByUrl: showModelByUrl,
            showModelByFile: showModelByFile,
            is3DModelRendered: is3DModelRendered,

            clippingEnabled: clippingEnabled,
            groundPlaneEnabled: groundPlaneEnabled,
            autoRotateEnabled: autoRotateEnabled,
            toggleAutoRotate: toggleAutoRotate,

            clippingAxis: clippingAxis,
            clippingAmount: clippingAmount,
            clippingFlipDirection: clippingFlipDirection,

            setRenderingData: setRenderingData,
            useDefaultRenderingData: useDefaultRenderingData,

            getCameraPosition: getCameraPosition,
            setCameraPosition: setCameraPosition,

            resize: resize,

            abort: abort,
            destroy: destroy
        };

        function canBeShownBy3DViewer(previewInfo) {
            return angular.isObject(previewInfo)
                && previewInfo.url
                && previewInfo.fileSizeBytes / 1024 <= settings.maxModelSizeKb
                && isWebGlSupported()
                && MSV.isFormatSupported(previewInfo.url);
        }

        function canBeShowDirectly(file) {
            if (!angular.isObject(file)) {
                return false;
            }

            return file.size / 1024 <= settings.maxModelSizeKb
                && isWebGlSupported()
                && MSV.isFormatSupported(file.name);
        }

        function isWebGlSupported() {
            if (isWebGlSupportedCached === null) {
                isWebGlSupportedCached = MSV.isWebGLSupported();
            }

            return isWebGlSupportedCached;
        }

        function isFormatSupported(fileName) {
            return MSV.isFormatSupported(fileName);
        }

        function initViewer($scope, containerElement) {
            guard.argumentIsObject($scope, "$scope");
            guard.argumentIsObject(containerElement, "containerElement");

            $scope.$on("$destroy", destroy);

            if (!msvWidget) {
                msvWidget = new MSV.Widget(containerElement.get(0));
                eventService.notify('viewerInit');
            }
        }

        function showModelByUrl(modelUrl) {
            guard.argumentIsString(modelUrl, "modelUrl");

            return loadModelIntoStlViewer(modelUrl);
        }

        function showModelByFile(file) {
            guard.argumentIsObject(file, "file");

            return loadModelIntoStlViewer(file);
        }

        function is3DModelRendered() {
            return msvWidget && msvWidget.isModelRendered();
        }

        function clippingEnabled(value) {
            if (angular.isUndefined(value)) {
                return getClippingEnabled();
            }

            setClippingEnabled(value);

            return angular.undefined;
        }

        function getClippingEnabled() {
            return msvWidget && msvWidget.isClipping();
        }

        function setClippingEnabled(enabled) {
            if (!msvWidget) {
                return;
            }

            if (enabled) {
                msvWidget.turnClippingOn();
            } else {
                msvWidget.turnClippingOff();
            }
        }

        function groundPlaneEnabled(value) {
            if (angular.isUndefined(value)) {
                return getGroundPlaneEnabled();
            }

            setGroundPlaneEnabled(value);

            return angular.undefined;
        }

        function getGroundPlaneEnabled() {
            return msvWidget && msvWidget.isGroundPlaneVisible();
        }

        function setGroundPlaneEnabled(enabled) {
            if (!msvWidget) {
                return;
            }

            if (enabled) {
                msvWidget.turnGroundPlaneOn();
            } else {
                msvWidget.turnGroundPlaneOff();
            }
        }

        function autoRotateEnabled(value) {
            if (angular.isUndefined(value)) {
                return getAutoRotateEnabled();
            }

            setAutoRotateEnabled(value);

            return angular.undefined;
        }

        function getAutoRotateEnabled() {
            return msvWidget && msvWidget.getCameraAutoRotation();
        }

        function setAutoRotateEnabled(enabled) {
            if (!msvWidget) {
                return
            }

            if (enabled) {
                msvWidget.setCameraAutoRotationOn();
            } else {
                msvWidget.setCameraAutoRotationOff();
            }
        }

        function toggleAutoRotate() {
            if (!msvWidget) {
                return
            }

            if (autoRotateEnabled()) {
                setAutoRotateEnabled(false);
            } else {
                setAutoRotateEnabled(true);
            }

            eventService.notify('viewerToggleAutoRotate');
        }

        function clippingAxis(value) {
            if (angular.isUndefined(value)) {
                return getClippingAxis();
            }

            setClippingAxis(value);
            return angular.undefined;
        }

        function getClippingAxis() {
            if (!msvWidget) {
                return null;
            }

            return msvWidget.getClippingAxis();
        }

        function setClippingAxis(value) {
            guard.argumentHasValue(value);

            if (!msvWidget) {
                return;
            }

            var axis = parseInt(value);
            if (axis !== MSV.Widget.axis.X && axis !== MSV.Widget.axis.Y && axis !== MSV.Widget.axis.Z) {
                throw new Error('ClippingAxis is out of range: ' + value);
            }

            var amount = getClippingAmount();
            var flipDirection = getClippingFlipDirection();

            msvWidget.setClippingPlane(axis, amount, flipDirection);
        }

        function clippingAmount(value) {
            if (angular.isUndefined(value)) {
                return getClippingAmount();
            }

            setClippingAmount(value);
            return angular.undefined;
        }

        function getClippingAmount() {
            if (!msvWidget) {
                return null;
            }

            return msvWidget.getClippingAmount();
        }

        function setClippingAmount(value) {
            guard.argumentHasValue(value);

            if (!msvWidget) {
                return;
            }

            var amount = parseFloat(value);

            var axis = getClippingAxis();
            var flipDirection = getClippingFlipDirection();

            msvWidget.setClippingPlane(axis, amount, flipDirection);
        }

        function clippingFlipDirection(value) {
            if (angular.isUndefined(value)) {
                return getClippingFlipDirection();
            }

            setClippingFlipDirection(value);
            return angular.undefined;
        }

        function getClippingFlipDirection() {
            if (!msvWidget) {
                return null;
            }

            return msvWidget.getClippingFlipDirection();
        }

        function setClippingFlipDirection(value) {
            guard.argumentHasValue(value);

            if (!msvWidget) {
                return;
            }

            var axis = getClippingAxis();
            var amount = getClippingAmount();
            var flipDirection = value;

            msvWidget.setClippingPlane(axis, amount, flipDirection);
        }

        function setRenderingData(renderingData) {
            guard.argumentIsObject(renderingData, "renderData");

            if (!msvWidget) {
                return;
            }

            var diffuseHex = rgbaStringToHex(renderingData.diffuseColor);
            var specularHex = rgbaStringToHex(renderingData.specularColor);
            var shinenessInt = parseInt(renderingData.shineness);
            shinenessInt = isNaN(shinenessInt) ? 32 : shinenessInt;

            msvWidget.setMaterial(diffuseHex, specularHex, shinenessInt);
        }

        function useDefaultRenderingData() {
            if (msvWidget) {
                msvWidget.restoreOriginalMaterial();
            }
        }

        function abort() {
            if (msvWidget) {
                $log.debug("StlViewer: abort operations.");
                msvWidget.abort();
            }
        }

        function destroy() {
            if (msvWidget) {
                msvWidget.dispose();
                msvWidget = null;
                eventService.notify('viewerDestroy');
            }
        }

        function getCameraPosition() {
            if (msvWidget) {
                return msvWidget.getCameraPosition();
            }

            return null;
        }

        function setCameraPosition(position) {
            if (msvWidget) {
                msvWidget.setCameraPosition(position);
            }
        }

        function resize() {
            if (msvWidget) {
                msvWidget.resize();
            }
        }

        // -------------------------------------------------------------------------------------------------------------------

        function loadModelIntoStlViewer(data) {
            var deferred = $q.defer();

            msvWidget.clear();
            msvWidget.load(data)
                .then(function (model) {
                    $log.debug("StlViewer: model loaded:", model);
                    deferred.resolve(data);
                })
                .catch(function (error) {
                    $log.debug("StlViewer: load model failed. reason:", error);
                    if (error && error.message === "Aborted") {
                        deferred.reject("CANCELED");
                    } else {
                        deferred.reject(error);
                    }
                });

            return deferred.promise;
        }

        function rgbaStringToHex(rgbaString) {
            var components = rgbaString.split(',');
            var result = parseInt(components[0]) * 65536
                + parseInt(components[1]) * 256
                + parseInt(components[2]);
            return result;
        }
    }
}());